import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cadenas.svg';
import { MDM_TOGGLE_ALMA } from '~/const/featureFlags';
var MdmLink = () => import('~/components/atoms/MdmLink.vue');
export default {
  name: 'Payment',
  components: {
    MdmLink
  },
  props: {
    isScrambleLink: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    urlPrefix() {
      return "".concat(this.locale.market, "/").concat(this.locale.language);
    },
    bancontact() {
      return this.locale.market === 'BE' ? 'Bancontact / ' : '';
    },
    isAlmaEnabled() {
      return this.$isEnabled(MDM_TOGGLE_ALMA, this.locale.iso);
    },
    paymentMethod() {
      return this.isAlmaEnabled ? this.$t('footer.secure_payment_alma') : this.$t('footer.secure_payment_list');
    }
  })
};